export default __webpack_public_path__ + "static/media/live-icon-active.5b6d2ff8.webp";